import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteDmsDealerMutation } from "modules/DMSv3/Settings/components/AddEditDealerModal/hooks";

import type { DeleteDmsDealerPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal/hooks";

type DeleteDmsDealerModalProps = {
  deleteDmsDealerPayload: DeleteDmsDealerPayload | null;
  onCancel: () => void;
  onClose: () => void;
};

export const DeleteDmsDealerModal = ({ deleteDmsDealerPayload, onCancel, onClose }: DeleteDmsDealerModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteDmsDealer, isPending: isDeleteDmsDealerPending } = useDeleteDmsDealerMutation();

  const handleDeleteDmsDealer = async () => {
    if (!deleteDmsDealerPayload) return;
    await deleteDmsDealer(deleteDmsDealerPayload);
    onClose();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={deleteDmsDealerPayload !== null}
      handleCancel={onCancel}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteDmsDealer}
      isLoading={isDeleteDmsDealerPending}
    />
  );
};
